import type { ContractDocType } from '../enums'

export interface DocumentLink {
    type: ContractDocType
    url: string
    description: string
    isLegalType: boolean
}

export type Document = {
    id: number
    docType: string
    name: string
    date: Date
    /**
     * Content URL for this row. Legacy InsurerOfferData rows are relative to the document API base;
     * HttpRequestLog rows are absolute. Use {@link resolveDocumentHref} to turn it into the href.
     */
    url: string
}

/**
 * Href for a document row: absolute URLs (e.g. HttpRequestLog content, built off the app's AppUrl) are used
 * as-is; relative ones (legacy InsurerOfferData) are appended to the document API base.
 */
export const resolveDocumentHref = (documentBaseUrl: string | null | undefined, doc: Pick<Document, 'url'>) =>
    /^https?:\/\//i.test(doc.url) ? doc.url : `${documentBaseUrl}/${doc.url}`